import React from "react";
import { useTranslation } from "react-i18next";

import sharePlaceholderImage from "../../assets/share.png";
import styles from "./ShareCard.module.css";

const isAndroid = () => {
	const ua = navigator.userAgent.toLowerCase();
	const isAndroid = ua.indexOf("android") > -1;
	if (isAndroid) {
		return true;
	} else {
		return false;
	}
};

const share = (t) => {
	const appLink = "https://apps.apple.com/bg/app/betway-scores-football-news/id1552348455";
	const appLinkAndroid = "https://play.google.com/store/apps/details?id=com.betway.scores.android&pcampaignid=web_share";

	const iOSTitle = t("common.shareCard.shareTitle");
	const androidTitle = t("common.shareCard.shareTitle");
	const shareBody = t("common.shareCard.shareBody");
	const shareBodyAndroid = t("common.shareCard.shareBody");

	if (navigator.share) {
		navigator
			.share({
				title: iOSTitle,
				text: shareBody,
				url: appLink,
			})
			.then(() => {
				// Share completed successfully
			})
			.catch((error) => console.error("Error sharing:", error));
	} else if (isAndroid()) {
		try {
			// @ts-expect-error - TS doesn't know that Android is a global object passed from the Android app
			Android.shareData(androidTitle, shareBodyAndroid, appLinkAndroid);
		} catch (error) {
			console.error("Error sharing on android:", error);
		}
	} else {
		console.warn("Web share not supported");
	}
};

const ShareCard = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.card}>
			<img src={sharePlaceholderImage} alt="Friends looking at phone" className={styles.image} />
			<div className={styles.contentContainer}>
				<h2 className={styles.title}>{t("common.shareCard.title")}</h2>
				<p className={styles.description}>{t("common.shareCard.description")}</p>
				<button
					className={styles.button}
					onClick={() => {
						share(t);
					}}
				>
					{t("common.shareCard.button")}
				</button>
			</div>
		</div>
	);
};

export default ShareCard;
